'use client';

import { Avatar as NextUIAvatar, AvatarProps as NextUIAvatarProps } from '@nextui-org/react';
import Image from 'next/image';
import React, { useMemo } from 'react';

interface AvatarProps extends NextUIAvatarProps {
  fallback?: React.ReactNode;
  type?: 'image' | 'icon' | 'avatar';
}

const Avatar: React.FC<AvatarProps> = (props) => {
  const type = props.type || 'avatar';
  const fallback = useMemo(() => {
    if (type === 'image') {
      return (
        <Image src='/assets/icons/image-fallback.svg' alt='image-fallback' width={32} height={32} />
      );
    }
    if (type === 'avatar') {
      return (
        <Image
          src='/assets/icons/avatar-fallback.svg'
          alt='avatar-fallback'
          width={32}
          height={32}
        />
      );
    }
    return (
      <Image src='/assets/icons/avatar-fallback.svg' alt='avatar-fallback' width={32} height={32} />
    );
  }, [type]);

  return (
    <NextUIAvatar
      {...props}
      fallback={fallback}
      classNames={{
        base: 'bg-gray-50 !border-1 !border-gray-100',
        icon: 'text-black/80',
        ...props.classNames,
      }}
    />
  );
};

export default Avatar;
